import { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"
import { SelectHistoricFilter } from "shared/components/molecules/SelectHistoricFilter/SelectHistoricFilter"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as LockerIcon } from 'assets/icons/historic/locker.svg'

import { Container, Content, ReturnButton } from "./_historic"
import { HistoricDetailsModal } from "shared/components/molecules/HistoricDetailsModal/HistoricDetailsModal"
import { DateFilterModal } from "shared/components/molecules/DateFilterModal/DateFilterModal"
import { ServicesFilterModal } from "shared/components/molecules/ServicesFilterModal/ServicesFilterModal"
import { StatusFilterModal } from "shared/components/molecules/StatusFilterModal/StatusFilterModal"
import { IAppointments } from "./interfaces"
import api from "services/api"
import { parseDate } from "utils/parseDate"
import { CategoryIcon } from "shared/components/atoms/CategoryIcon"

export interface IFilterProps {
  status?: string;
  date?: string;
  services?: string;
}

export interface IFilterModal {
  status: boolean;
  date: boolean;
  services: boolean;
}

export const Historic = () => {
  const items = Array(10).fill(1);

  const [filterQuery, setFilterQuery] = useState('')
  const [showFilterModal, setShowFilterModal] = useState({
    status: false,
    date: false,
    services: false,
  } as IFilterModal)

  const [showDetails, setShowDetails] = useState(false);
  const [appointmentDetailCode, setAppointmentDetailCode] = useState<undefined | number>();

  const [appointments, setAppointments] = useState<IAppointments[]>([]);

  useEffect(() => {
    fetchHistoric();
  }, [filterQuery]);

  const fetchHistoric = async () => {
    try {
      const response = await api.get<{
        service_appointments: IAppointments[]
      }>(`/appointments?${filterQuery}`);
      setAppointments(response.data.service_appointments);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message)
    }
  }

  const handleOpenDetailsModal = (code: number) => {
    setAppointmentDetailCode(code);
    setShowDetails(true);
  }

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <ReturnButton to="/">
          <LeftArrow
            className="historic__content-icon"
          />
        </ReturnButton>

        <div className="historic__wrapper">
          <SelectHistoricFilter
            className="historic__filter"
            setShowFilterModal={setShowFilterModal}
          />
          <ul className="historic__ul">
            {/* {items.map(() => (
            <li className="historic__li">
              <article className="historic__article">
                <div className="historic__article-content">
                  <div className="historic__icon-container">
                    <LockerIcon />
                  </div>
                  <div className="historic__details-container">
                    <h1 className="historic__details-title">
                      MONTAGEM DE MÓVEIS - Cláudio Lemos
                    </h1>
                    <h2 className="historic__details-item">
                      Dia 05/02/2021 ás 10:00
                    </h2>
                    <h2 className="historic__details-item">
                      Valor do Serviço: R$ 90,00
                    </h2>
                    <span className="historic__details-id">
                      Nº23010
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="historic__details-button"
                  onClick={() => setShowDetails(true)}
                >
                  Ver detalhes
                </button>
              </article>
            </li>
            ))} */}
            {
              appointments.map(appointment => (
                <li className="historic__li">
                  <article className="historic__article">
                    <div className="historic__article-content">
                      <div className="historic__icon-container">
                        <CategoryIcon categoryId={Number(appointment?.service_type_id)} dark/>
                      </div>
                      <div className="historic__details-container">
                        <h1 className="historic__details-title">
                          <span className="historic__details-service-name">{appointment.service_type.name}</span> - {appointment?.user?.individual_person?.name}
                        </h1>
                        <h2 className="historic__details-item">
                          {
                            parseDate(appointment.service_solicitation.date)
                          }
                        </h2>
                        <h2 className="historic__details-item">
                          Valor do Serviço: {
                            new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(Number(appointment.service_solicitation.price) / 100)
                          }
                        </h2>
                        <span className="historic__details-id">
                          Nº {appointment.code}
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="historic__details-button"
                      onClick={() => handleOpenDetailsModal(Number(appointment.code))}
                    >
                      Ver detalhes
                    </button>
                  </article>
                </li>
              ))
            }
          </ul>
        </div>
      </Content>
      {showFilterModal.status && (
        <StatusFilterModal
          toggleModal={setShowFilterModal}
          setFilterQuery={setFilterQuery}
        />
      )}
      {showFilterModal.date && (
        <DateFilterModal
          toggleModal={setShowFilterModal}
          setFilterQuery={setFilterQuery}
        />
      )}
      {showFilterModal.services && (
        <ServicesFilterModal
          toggleModal={setShowFilterModal}
          setFilterQuery={setFilterQuery}
        />
      )}
      {showDetails && (
        <HistoricDetailsModal
          toggleModal={setShowDetails}
          code={appointmentDetailCode}
        />
      )}
    </Container>
  )
}
